import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Row = ({ label, date, time, onDate, onTime, testid }) => (
  <div className="grid grid-cols-2 sm:grid-cols-[180px_1fr_1fr] gap-2 items-center" data-testid={`timing-row-${testid}`}>
    <span className="col-span-2 sm:col-span-1 text-sm font-medium text-slate-300">{label}</span>
    <Input type="date" min="2000-01-01" max="2099-12-31" aria-label={`${label} giorno`} value={date || ""}
      onChange={(e) => onDate(e.target.value)} data-testid={`timing-${testid}-date-input`} />
    <Input value={time || ""} onChange={(e) => onTime(e.target.value)} aria-label={`${label} orario`}
      placeholder="orario" className="font-mono" data-testid={`timing-${testid}-time-input`} />
  </div>
);

export const TimingFields = ({ q, update }) => {
  const days = q.show_days || [];
  const setDay = (i, patch) => update({ show_days: days.map((d, j) => (j === i ? { ...d, ...patch } : d)) });
  return (
    <div className="sm:col-span-4 space-y-2" data-testid="timing-fields">
      <div className="grid grid-cols-2 sm:grid-cols-[180px_1fr_1fr] gap-2 micro-label">
        <Label className="micro-label col-span-2 sm:col-span-1">Timing</Label>
        <span className="hidden sm:block">Giorno</span><span className="hidden sm:block">Orario</span>
      </div>
      <Row label="Allestimento" testid="setup" date={q.setup_date} time={q.setup_time}
        onDate={(v) => update({ setup_date: v })} onTime={(v) => update({ setup_time: v })} />
      {days.length === 0 && <p className="text-xs text-slate-500" data-testid="timing-show-empty">Inserisci le date dell'evento: i giorni di svolgimento si compilano da soli.</p>}
      {days.map((d, i) => (
        <Row key={i} label={`Svolgimento giorno ${i + 1}`} testid={`show-${i}`} date={d.date} time={d.time}
          onDate={(v) => setDay(i, { date: v })} onTime={(v) => setDay(i, { time: v })} />
      ))}
      <Row label="Smontaggio" testid="teardown" date={q.teardown_date} time={q.teardown_time}
        onDate={(v) => update({ teardown_date: v })} onTime={(v) => update({ teardown_time: v })} />
    </div>
  );
};
